















import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import ScreenGuard from '@/components/ScreenGuard.vue';
import {processModule} from '@/store/process/process';
import VersionDialog from '@/views/VersionDialog.vue';

@Component({
  components: {
    Header,
    ScreenGuard,
    VersionDialog,
  },
})
export default class App extends Vue {

  // computed
  get onLogonPage(): boolean {
    return this.$route.path === '/logon';
  }

  get backgroundClassName(): string {
    if (this.onLogonPage) {
      return 'has-login-background';
    }
    return 'has-general-background';
  }

  get isProcessing(): boolean {
      return processModule.処理中;
  }

  // methods
  private openVersionDialog() {
    this.$modal.show('VersionDialog');
  }
}
